<template lang="pug">
    div.dropdown__wrapper(:class="{'disabled': disabled ,'is-open': opened}")
        div.label(@click="toggle") {{getLabel(value)}}
            div.arrow
                span.arrowHalf.left
                span.arrowHalf.right
        ul.dropdown
            li(v-for="(o, key) in options" :value="key" :class="{active: value === key}" @click="change(key)") {{o}}
        div.overlay(v-if="opened" @click="toggle")
</template>

<script>
    export default {
        name: "Dropdown",
        props: {
            value: {
                required: true
            },
            options: {
                type: Object,
                required: true
            },
            disabled: {
                type: Boolean,
            }
        },
        data: function () {
            return {
                opened: false
            }
        },
        methods: {
            getLabel(val) {
                return this.options[val]
            },
            change(key) {
                this.$emit('input', key);
                this.opened = false;

                if (this.onChange !== undefined) {
                    this.onChange(this.value)
                }
            },
            toggle() {
                if (this.disabled) {
                    return
                }
                this.opened = !this.opened
            }
        }
    }
</script>

<style scoped lang="scss">

    .dropdown__wrapper {
        position: relative;
        color: #2e2e2e;
        outline: none;
        cursor: pointer;

        &.is-open {
            .label {
                color: #0027ff;
                .arrow {
                    .left {
                        &:after {
                            transform-origin: center center;
                            transform: rotate(-70deg);
                        }
                    }
                    .right {
                        &:after {
                            transform-origin: center center;
                            transform: rotate(70deg);
                        }
                    }
                }
            }
            .dropdown {
                opacity: 1;
                pointer-events: auto;
                transform: scale(1) translateY(0);
            }
        }
        .label {
            position: relative;
            font-weight: 500;
            color: #000;
            font-size: 16px;
            width: 100%;
            border-radius: 5px;
            padding: 7px 24px 7px 7px;
            display: table-cell;
            transition: color .3s ease;
            &:hover {
                color: #0027ff;
            }
            .arrow {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                width: 16px;
                display: flex;
                justify-content: center;
                cursor: pointer;
                .arrowHalf {
                    position: absolute;
                    top: 15px;
                    width: 8px;
                    height: 7px;
                    border-radius: 2px;
                    background-color: transparent;
                    transform: translateX(-50%) rotate(40deg);
                    display: block;
                    float: right;
                    &:after {
                        content: "";
                        background-color: #ababab;
                        width: 8px;
                        height: 2px;
                        display: block;
                        float: right;
                        border-radius: 6px 10px 10px 6px;
                        transition: all 0.5s cubic-bezier(0.25, 1.7, 0.35, 0.8);
                        z-index: -1;
                    }
                }

                .right {
                    transform: translateX(50%) rotate(-40deg);
                    &:after {
                        border-radius: 10px 6px 6px 10px;
                    }
                }
            }
        }
        .dropdown {
            position: absolute;
            top: 100%;
            left: 0;
            min-width: 170px;
            border-radius: 5px;
            background-color: #fff;
            margin-top: 7px;
            opacity: 0;
            pointer-events: none;
            transform-origin: 50% 0;
            transform: scale(0.75) translateY(-21px);
            box-shadow: 0 0 0 1px rgba(68, 88, 112, 0.11);
            transition: all 0.2s cubic-bezier(0.5, 0, 0, 1.25), opacity 0.15s ease-out;
            overflow: hidden;
            padding: 10px 0;
            z-index: 9999;

            li {
                font-size: 13px;
                font-weight: 500;
                line-height: 34px;
                list-style: none;
                color: #555555;
                min-height: 34px;
                outline: none;
                padding: 0 20px;
                text-align: left;
                transition: all 0.2s;
                cursor: pointer;
                &.active,
                &:hover {
                    background-color: #eee;
                    cursor: pointer;
                }
            }
        }
        .overlay {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            z-index: 999;
        }

        @media (max-width: 768px) {
            .label {
                font-size: 14px;
                line-height: 19px;
                white-space: nowrap;
                margin: 0 0 5px;
                padding: 7px 0;
                .arrow {
                    display: none;
                }
            }
        }
    }
</style>
